import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
})
export default class VCustomTextField extends Vue {
  @Prop()
  value: any;
  @Prop()
  id: any;
  @Prop()
  name: any;
  @Prop()
  dataCy: any;
  @Prop()
  label: any;
  @Prop()
  errorMessages: any;
  @Prop()
  dense: false;
  @Prop()
  outlined: false;
  @Prop()
  required: false;
  @Prop()
  readonly: false;
  @Prop()
  disabled: false;
  @Prop()
  singleLine: false;
  @Prop()
  title: any;
  @Prop({ default: 'auto' })
  hideDetails: any;
  @Prop({ default: 'text' })
  type: string;
}
